export enum ShadowBoxSize {
  sm = "shadow-sm",
  base = "shadow",
  md = "shadow-md",
  lg = "shadow-lg",
  xl = "shadow-xl",
  xxl = "shadow-2xl",
  inner = "shadow-inner",
  none = "shadow-none",
}
